import React from "react";

//pages
import DashboardPage from "@pages/Dashboard/DashboardPage";
import MapPage from "@pages/Map/MapPage";

//react route
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import { PrivateRoute } from "./PrivateRoute";

//Util
// import MenuBar from '../components/MenuBar';
import LoginPage from "@pages/Login/LoginPage";
import { AdminRoute } from "./AdminRoute";
import { DefaultRoute } from "./DefaultRoute";
import MenuBar from "@components/MenuBar/MenuBar";
import NewContractToast from "@components/NewContractToast";
import RoutesPage from "@pages/Routes/RoutesPage";
import ReturnsPage from "@pages/Returns/ReturnsPage";
import UsersPage from "@pages/Users/UsersPage";
import { PrivateRoute } from "./PrivateRoute";
import OperatorMap from "@pages/OperatorMap/OperatorMap";
import UploadPage from "@pages/UploadPage/UploadPage";
import RemovePage from "@pages/RemovePage/RemovePage";
import DatabasePage from "@pages/DatabasePage/DatabasePage";
import SystemLogsPage from "@pages/SystemLogs/SystemLogsPage";
import CloseRoutesLogsPage from "@pages/CloseRoutesLogs/CloseRoutesLogsPage";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/map"
          element={
            <PrivateRoute redirectTo={"/"}>
              <OperatorMap />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <DashboardPage />
                <NewContractToast />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/adminMapPage"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <MapPage />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/adminRoutesPage"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <RoutesPage />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/adminReturnsPage"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <ReturnsPage />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/manageUsers"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <UsersPage />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/upload"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <UploadPage />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/remove"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <RemovePage />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/databasePage"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <DatabasePage />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/closeRoutesLogs"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <CloseRoutesLogsPage />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/systemLogs"
          element={
            <AdminRoute redirectTo={"/"}>
              <>
                <MenuBar />
                <SystemLogsPage />
              </>
            </AdminRoute>
          }
        />
        <Route
          path="/"
          element={
            <DefaultRoute>
              <LoginPage />
            </DefaultRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
